import globals from "@/styles/partials/global-variables";
import { NarrowLongBlackArrow } from "@/styles/partials/icons";
import { LinkText, NormalText } from "../partials/texts";

export default {
  container: {
    ...NormalText,
    "& .product-properties, & .properties-title, & .product-attributes-toggle, & .compare-wrapper": {
      display: "none"
    },
    marginBottom: "20px",
    "& .product-name": {
      ...LinkText,
      display: "block",
      fontSize: globals.fontSize.sm,
      fontWeight: "600",
      marginBottom: "10px"
    },
    textAlign: "center",
    "& .product-image": {
      marginBottom: "10px",
      "& > a": {
        display: "flex"
      },
      "& img": {
        margin: "0 auto",
        height: "100%",
        width: "100%",
        maxHeight: "345px",
        maxWidth: "345px"
      }
    },
    "& .product-price": {
      color: globals.colors.gray5,
      fontSize: globals.fontSize.xs,
      marginBottom: "20px"
    },
    "& .product-footer": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",

      "& .product-button": {
        ...LinkText,
        fontSize: globals.fontSize.xs
      },
      "& .go-to-product-button": {
        borderBottom: "1px solid #000",
        paddingBottom: "2px",
        position: "relative",
        paddingRight: "20px",
        "&:after": {
          ...NarrowLongBlackArrow,
          right: "0px!important"
        }
      }
    }
  }
};
